import { fetchFoodInfo } from './foodService.js';

export class GroceryController {
  constructor(model, view) {
    this.model = model;
    this.view = view;

    this.model.subscribeGroceryListChanged(this.onGroceryListChanged);
    this.view.onAddGrocery(this.handleAddGrocery);
    this.view.onDeleteGrocery(this.handleDeleteGrocery);

    // Defer initial render until stylesheets are applied.
    requestAnimationFrame(() => {
      this.onGroceryListChanged(this.model.groceries);
    });
  }

  onGroceryListChanged = (groceries) => {
    this.view.displayGroceries(groceries);
  };

  handleAddGrocery = async (itemName, quantity) => {
    const index = this.model.groceries.length;
    this.model.addGrocery(itemName, quantity);
    const productInfo = await fetchFoodInfo(itemName);
    // Guard against stale index if items were added/deleted while the fetch was in flight.
    if (this.model.groceries[index]?.itemName === itemName) {
      this.model.updateProductInfo(index, productInfo ?? { notFound: true });
    }
  };

  handleDeleteGrocery = (index) => {
    this.model.deleteGrocery(index);
  };
}
